import React from "react"

import "./PageContainer.css"
import { Box, Container, useTheme } from "@mui/material"

interface Props {
  children: JSX.Element | JSX.Element[]
}

export const PageContainer = ({ children }: Props) => {
  const { palette } = useTheme()
  return (
    <Box
      className="page-container-background"
      sx={{
        p: { xs: 0, md: 6, lg: 8 },
        flex: 1,
        minHeight: 0,
        display: { xs: "flex" }
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          borderRadius: { xs: "0px", md: "32px", lg: "40px" },
          boxShadow: "0px 3px 15px #0719390C",
          overflow: "auto",
          backgroundColor: palette.common.white,
          display: { xs: "flex" },
          flexDirection: "column",
          height: { md: "100%" },
          minHeight: 0,
          flex: 1
        }}
      >
        {children}
      </Container>
    </Box>
  )
}

export default PageContainer
